/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_Stopped_AgoInputs */

const en_us2_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time off`)
};

const pt_br2_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo parado`)
};

const es_419_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo sin entrenar`)
};

const pt_pt2_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo parado`)
};

const fr_fr2_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de l'arrêt`)
};

const de_de2_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause seit`)
};

const it_it2_profile_row_stopped_ago = /** @type {(inputs: Profile_Row_Stopped_AgoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di stop`)
};

/**
* | output |
* | --- |
* | "Time off" |
*
* @param {Profile_Row_Stopped_AgoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_stopped_ago = /** @type {((inputs?: Profile_Row_Stopped_AgoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_Stopped_AgoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_stopped_ago(inputs)
	if (locale === "es-419") return es_419_profile_row_stopped_ago(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_stopped_ago(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_stopped_ago(inputs)
	if (locale === "de-DE") return de_de2_profile_row_stopped_ago(inputs)
	if (locale === "it-IT") return it_it2_profile_row_stopped_ago(inputs)
	return en_us2_profile_row_stopped_ago(inputs)
});
export { profile_row_stopped_ago as "profile.row_stopped_ago" }